import { CalendarIcon, UpdateIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import api from '../../lib/api';
import { DatePickerSingle } from '../datePickerSingle';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '../ui/form';
import { toast } from '../ui/use-toast';

const ChangeCompetitionSportClassDateDialog = ({ sportClass, fetchCompetition }) => {

    const [isLoading, setIsLoading] = useState(false);
    const form = useForm();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [formData, setFormData] = useState({
        newDate: ''
    });

    const handleChange = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/competitions/edit-class-date`, {
                sportClassId: sportClass.id,
                ...formData
            });

            fetchCompetition();
            toast({
                title: 'Datum ändrat',
                description: `Datum ändrat för ${sportClass.name}.`,  // Using full class name
            });
            setIsDialogOpen(false);
        } catch (error) {
            //
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleDateChange = (date, name) => {
        if (!date) {

            return; // Early return if the date is null or undefined
        }


        setFormData(prevState => ({
            ...prevState,
            [name]: date.toLocaleString('sv').split(' ')[0], // Update the specific field (startDate, endDate, etc.)
        }));
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <CalendarIcon className='mr-3' />
                    Ändra datum
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>
                        Ändra datum för {sportClass.name}
                    </DialogTitle>
                    <DialogDescription>
                        Ange information för att ändra datum för klassen.
                    </DialogDescription>
                </DialogHeader>
                <Form {...form}>
                    <form onSubmit={handleChange} className="flex flex-col gap-6">
                        <FormField
                            control={form.control}
                            name="newDate"
                            render={({ field }) => (
                                <FormItem className='space-y-0 grid gap-2'>
                                    <FormLabel>Datum för klassen</FormLabel>
                                    <FormControl>
                                        <DatePickerSingle onDateChange={(date) => handleDateChange(date, field.name)} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <div className='grid grid-cols-2 gap-3'>
                            <DialogClose asChild>
                                <Button type='button' variant='secondary'>Avbryt</Button>
                            </DialogClose>
                            <Button
                                onClick={handleChange}
                                disabled={isLoading}>
                                {(isLoading) ? <UpdateIcon className='loader-spinner' /> : <>Ändra</>}
                            </Button>
                        </div>
                    </form>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

export default ChangeCompetitionSportClassDateDialog;
